import { COLORS } from '../../../theme/themeConstants';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

type AddRestaurantProps = {
  onCancel: () => void;
  storeTypeOnEdit: ("GroceryStore" | "PharmacyStore" | "Restaurant")[] | undefined;
};
const SelectStore = ({ storeTypeOnEdit }: AddRestaurantProps) => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '1rem' }}>
      {/* Label and Select Dropdown aligned like the image */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1rem',
          marginLeft: '117px',
        }}
      >
        <label
          htmlFor="storeType"
          style={{
            width: '125px',
            fontWeight: 500,
            fontSize: '14px',
            color: COLORS.text.primary,
            fontFamily: 'livvic',
          }}
        >
          {t('storeManagement.form.storeType')} <span style={{ color: 'red' }}>*</span>
        </label>

        <TextField
          // disabled={true}
          value={storeTypeOnEdit?.join(', ') || ''}
          fullWidth
          sx={{ width: '396px', marginLeft: '13px', pointerEvents: 'none'}}
          InputProps={{
            readOnly: true, // User can click, but not edit
          }}
        />
        {/* <select
          id="storeType"
          value={storeType}
          onChange={(e) => setStoreType(e.target.value)}
          style={{
            marginLeft: '13px',
            padding: '8px 12px',
            fontSize: '14px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '396px',
            backgroundColor: '#fff',
            appearance: 'none',
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23999' stroke-width='1.5'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '12px',
          }}
        >
          <option value="">-- Select --</option>
          {storeOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select> */}
      </div>


    </div>
  );
};

export default SelectStore;
